import * as ContentDisposition from 'content-disposition';

export default function saveBlobAsFile(response) {
    const data = response.data;
    const filename = ContentDisposition.parse(response.headers['content-disposition']).parameters.filename;

    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(data, filename);
    } else {
        const blobURL = window.URL.createObjectURL(data)
        const link = document.createElement('a')
        document.body.appendChild(link)

        link.download = filename
        link.href = blobURL
        link.click()
        link.remove()
    }
}